






































import { Button, SortableTable } from "@micad/vue-components";

import { Client } from "@/assets/js/constants";
import { defineComponent, reactive } from "@vue/composition-api";
import Loading from "@/components/Loading.vue";
import router from "@/router";
import {
  TableColumn,
  TableFilter,
} from "@micad/vue-components/src/common/interfaces";
import { getClients } from "@/data/repos/client";
import { canIUse } from "@/modules/auth";

const columns = [
  {
    name: "key",
    label: "Client key",
    align: "left",
    field: (row: Client) => row.key,
    classes: "primary",
    sortable: true,
    filter: true,
    customBodyRender: (row: Client) =>
      `<p class="hover:cursor-pointer">${row.key || ""}</p>`,
  },
  {
    name: "name",
    label: "Name",
    align: "left",
    field: (row: Client) => row.name || "",
    classes: "primary",
    sortable: true,
    filter: true,
  },
  {
    name: "type",
    label: "Type",
    align: "left",
    field: (row: Client) => row.type || "",
    classes: "primary",
    sortable: true,
    filter: true,
  },
  {
    name: "logoUrl",
    label: "Logo URL",
    align: "left",
    field: (row: Client) => row.logoUrl,
    classes: "primary",
    sortable: true,
    filter: true,
    customBodyRender: (row: Client) =>
      `<a target="_blank" href="${row.logoUrl}">${row.logoUrl || ""}</a>`,
  },
  {
    name: "active",
    label: "Active",
    align: "center",
    field: (row: Client) => row.active || false,
    classes: "primary",
    sortable: true,
    filter: true,
    customBodyRender: (row: Client) =>
      `<input  type="checkbox" ${
        row.active ? "checked" : ""
      } onclick="return false;"/>`,
  },
];

export default defineComponent({
  name: "Clients",
  components: {
    SortableTable,
    Button,
    Loading,
  },
  setup() {
    const applyFilters = async function (filters: TableFilter[]) {
      let clients = state.allClients;
      state.loaded = false;

      function rowSearch(column: string, searchValue: string) {
        return String(column)
          .toLowerCase()
          .includes(String(searchValue).toLowerCase());
      }

      filters.forEach(function (filter: TableFilter) {
        const searchValue = String(filter.sendValue);

        switch (filter.name) {
          case "active":
            if (searchValue !== "undefined") {
              clients = clients.filter(
                (row) => row.active === (searchValue === "yes" ? true : false)
              );
            }
            break;

          case "key":
            if (searchValue && searchValue != "") {
              clients = clients.filter((row) =>
                rowSearch(row.key, searchValue)
              );
            }
            break;

          case "name":
            if (searchValue != "") {
              clients = clients.filter((row) =>
                rowSearch(String(row.name), searchValue)
              );
            }
            break;

          case "type":
            if (searchValue != "") {
              clients = clients.filter((row) =>
                rowSearch(String(row.type), searchValue)
              );
            }
            break;

          case "logoUrl":
            if (searchValue != "") {
              clients = clients.filter((row) =>
                rowSearch(row.logoUrl, searchValue)
              );
            }
            break;
        }
      });
      state.clients = clients;
      state.loaded = true;
    };
    const state = reactive({
      canIUse,
      applyFilters,
      goToClientCreate,
      actions,
      columns,
      clients: [] as Client[],
      allClients: [] as Client[],
      loaded: false,
      filters: [
        {
          name: "active",
          label: "Active",
          type: "select",
          value: { label: "yes", value: "yes" },
          options: [
            { label: "yes", value: "yes" },
            { label: "no", value: "no" },
          ],
        },
        {
          name: "key",
          label: "Client key",
          type: "text",
          value: "",
        },
        {
          name: "name",
          label: "Name",
          type: "text",
          value: "",
        },
        {
          name: "type",
          label: "Type",
          type: "text",
          value: "",
        },
        {
          name: "logoUrl",
          label: "Logo URL",
          type: "text",
          value: "",
        },
      ] as TableFilter[],
    });
    setTimeout(async () => {
      state.allClients = ((await getClients()).payload || []).sort(
        (a: Client, b: Client) =>
          a.key.toLowerCase() > b.key.toLowerCase() ? 1 : -1
      );
      state.clients = state.allClients;
      state.loaded = true;
    });
    function goToClientCreate() {
      router.push({ name: "ClientCreate" });
    }
    async function actions(col: TableColumn) {
      switch (col.name) {
        case "key":
          await router.push({
            name: "ClientDetails",
            params: { key: String(col.value) },
          });
          break;
        case "name":
          console.log("col", JSON.stringify(col));
          break;
      }
    }
    return state;
  },
});
